<!--
Component for the classes carousel.
@author crm4f
-->
<template>
  <div class="eventsCarouselContainer">

    <HomepageCarousel v-if="eventsToUse.length" name="events" :isPrimary="1===1">
      <CarouselItem v-bind:key="index" v-for="(event, index) in eventsToUse" :id ="'events' + index">
        <div class="timeContainer">
          <p>{{ formatEventTime(event.start) }}<br />-<br />{{ formatEventTime(event.end) }}</p>
        </div>
        <div class="infoContainer">
          <p id="eventTxt"><strong>{{ event.course }}</strong><br />{{ event.location }}</p>
          <p v-if="event.lecturer != null">{{ event.lecturer }}</p>
        </div>
      </CarouselItem>
    </HomepageCarousel>

    <div class="noEventsDiv" v-else>
      <!-- no classes -->
      <span>No more scheduled classes today.</span>
    </div>

    <ViewMoreButton :text="'View timetable'" :featureLink="'/timetable'" :isPrimary="1===1" ></ViewMoreButton>

  </div>
</template>

<script setup>
// import StringUtil from '@/mixins/StringUtil.js'
import axios from 'axios'
import HomepageCarousel from '@/components/homepage/HomepageCarousel.vue'
import CarouselItem from '@/components/homepage/CarouselItem.vue'
import ViewMoreButton from './ViewMoreButton.vue'
import { ref, onMounted } from 'vue'

const eventsToUse = ref([])
const timeTolerance = ref(15) // minutes

onMounted (() => {
  getEvents()
})

function getEvents () {
  axios.get('/timetable/timetable/events', {
    params: {
      // this could be probably be better
      start: dateToUnixTs(new Date(new Date() - (timeTolerance.value * 60 * 1000))),
      end: dateToUnixTs(new Date(new Date().setHours(23, 59, 59, 999))),
      ts: Date.now()
    }
  })
    .then(response => {
      eventsToUse.value = response.data
      // sort dates based on whats closest to now
      eventsToUse.value.sort((a, b) => {
        let dateA = new Date(a.start)
        let dateB = new Date(b.start)
        let now = Date.now()
        let diffA = Math.abs(now - dateA)
        let diffB = Math.abs(now - dateB)
        return diffA - diffB
      })
    })
    .catch((error) => {
      console.log(error)
    })
}

function formatEventTime (date) {
  let dateObj = new Date(date.replace(/-/g, '/'))
  return dateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).toLocaleLowerCase()
}

function dateToUnixTs (date) {
  return date.getTime() / 1000 | 0
}
  
</script>

<style>

.infoContainer {
  display: flex;
  flex-flow: column wrap;
  word-wrap: break-word;
  white-space: pre-line;
  justify-content: center;
  height: fit-content;
  margin: 5px;
  padding: 5px;
}

.swiper {
  width: 600px;
  height: 300px;
}

.timeContainer {
  display: flex;
  flex-flow: column wrap;
  padding: 5px;
  margin: 5px;
  justify-content: center;
}

#eventTxt {
  margin-bottom: 0px;
}

.timeContainer p {
  margin-bottom: 3px !important;
  height: fit-content;
  text-align: center;
}

.infoContainer p {
  margin-bottom: 0px;
}

.noEventsDiv {
  width: 75%;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

div.scrollover {
  height: 250px;
  overflow-x:auto;
  overflow-y:hidden;
  white-space: nowrap;

  -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.scrollover::-webkit-scrollbar {
  display: none;
}
</style>
